import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const SearchBoxContainer = styled.div`
  width: ${() => `${viewSizeCalculator(18.5)}`}; // 17.5rem
  min-width: ${() => `${viewSizeCalculator(18.5)}`}; // 17.5rem
  height: ${() => `${viewSizeCalculator(3.75)}`}; // 3.75rem
  gap: ${() => `${viewSizeCalculator(2.875)}`}; // 2.875rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  border: ${() => `${viewSizeCalculator(0.125)}`}; // 0.125rem
  opacity: 0rem;
  position: relative;

  background-color: #fff;
  border: ${() => `${viewSizeCalculator(0.16)} solid #ebebeb`};

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${() =>
    `${viewSizeCalculator(1.313)} ${viewSizeCalculator(1)}`}; // 0.625rem
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
  overflow: hidden;
  max-width: ${() => `${viewSizeCalculator(12.5)}`};
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1.063rem

  margin-left: ${() => `${viewSizeCalculator(1.75)}`}; // 1.75rem

  &::placeholder {
    color: #aaa;
    font-size: ${() => `${viewSizeCalculator(0.875)}`};
    font-weight: 400;
    line-height: ${() => `${viewSizeCalculator(1.059)}`};
  }
`;

export const SearchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  svg {
    width: ${() => `${viewSizeCalculator(1.125)}`}; // 1.125rem
    height: ${() => `${viewSizeCalculator(1.125)}`}; // 1.125rem
  }
`;

export const CrossWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right: ${() => `${viewSizeCalculator(0.8)}`};
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
  }
`;
